export default "__VITE_ASSET__BqWSkD_S__"